export const theme = {
  token: {
    colorPrimary: "#663399",
    colorInfo: "#663399",
    colorText: "#000",
    fontSize: 14,
    borderRadius: 4,
    fontFamily: '"Manrope", sans-serif',
  },
  components: {
    Button: {
      controlHeight: 40,
      defaultShadow: "none",
      // primaryShadow: "0 6px 16px rgba(255,0,140,.25)",
      primaryShadow: "none",
      fontWeight: 500,
    },
    Input: {
      activeBorderColor: "#663399",
      hoverBorderColor: "#663399",
      borderRadius: 6,
    },
    DatePicker: {
      borderRadius: 6,
    },
    Select: {
      borderRadius: 6,
      fontSizeLG: 14,
    },
    Divider: { margin: 4 },
  },
};
